import { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";

export default function AttendeeMatchButton({ iHaveMatchedThem, isMutual, onMatch, onUnmatch }) {
	const [show, setShow] = useState(false);

	if (iHaveMatchedThem) {
		return (
			<Dropdown
				show={show}
				onToggle={(isOpen) => setShow(isOpen)}
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
			>
				<Dropdown.Toggle
					variant={isMutual ? "success" : "warning"}
					size="sm"
					bsPrefix="btn"
					className="btn btn-sm"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						setShow((prev) => !prev);
					}}
				>
					{isMutual ? (
						<>
							<i className="bi bi-check-all" style={{ fontSize: "1.1rem", lineHeight: 0, verticalAlign: "middle" }}></i>{" "}
							Matched!
						</>
					) : (
						<>
							<i className="bi bi-check" style={{ fontSize: "1.1rem", lineHeight: 0, verticalAlign: "middle" }}></i>{" "}
							Matched
						</>
					)}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							setShow(false);
							onUnmatch();
						}}
					>
						<i className="bi bi-heartbreak-fill me-2"></i>Unmatch
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		);
	}

	return (
		<Button
			size="sm"
			variant="primary"
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				onMatch();
			}}
		>
			<i className="bi bi-arrow-through-heart-fill me-1"></i> Match
		</Button>
	);
}
